export default __webpack_public_path__ + "static/media/pg-18.35df4c7b.jpg";